<template>
  <div v-visible-track="'Iframe.ancientDnaAncientOriginsBreakdownPageViewed'">
    <div class="periodical" v-if="$store.state.appConfig.windowWidth >= 769">
      <div class="result-container">
        <PeriodicalProximity v-if="$store.state.periodicalResult.openedPeriodicalDetail.id"/>
        
        <template v-else>
          <div class="periodical-container cs-scroll-style">
            <PeriodicalTopHeader />
            <PeriodicalPopView />
          </div>
        </template>
      </div>
      <div class="map-container">
        <PeriodicalMap />
      </div>
    </div>

    <div class="periodical-mobile" v-else>
      <div v-if="$store.state.periodicalResult.openedPeriodicalDetail.id">
        <PeriodicalProximity />
      </div>
      <div class="mobile-result-container" v-else>
        <PeriodicalMap class="mobile-map" :height="height"/>
        <div class="mobile-container"
          :style="{ transform: 'translateY(' + contentPosition + 'px)' }">
          <div  :class="{'scrollable-wrapper': contentPosition === 0}">
            <div @touchstart="startDrag"
                @touchmove="onDrag"
                @touchend="endDrag">
                <PeriodicalTopHeader class="mobile-header" :contentPosition="contentPosition"/>
            </div>
            
            <PeriodicalPopView />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PeriodicalCalculateWatcher from '@/views/periodical/Services/PeriodicalCalculateWatcher'

import PeriodicalTopHeader from './PeriodicalTopHeader.vue';
import PeriodicalPopView from './details/PeriodicalPopView.vue';
import PeriodicalMap from './maps/PeriodicalMap.vue';
import PeriodicalProximity from './details/PeriodicalProximity.vue';

export default {
  components: {
    PeriodicalTopHeader,
    PeriodicalPopView,
    PeriodicalMap,
    PeriodicalProximity,
  },
  data() {
    return {
      startY: 0,
      height: 250,

      contentPosition: 250,
      prevPosition: 250,
      minPosition: 0,
      middelPosition: 250,
      maxPosition: 350,
    };
  },
  methods: {
    startDrag(event) {
      this.startY = event.touches[0].clientY - this.contentPosition;
      this.prevPosition = this.contentPosition;
    },
    onDrag(event) {
      let newY = event.touches[0].clientY - this.startY;
      if (newY < this.minPosition) {
        newY = this.minPosition;
      }
      if (newY > this.maxPosition) {
        newY = this.maxPosition;
      }
      if(newY >= 0) {
        this.contentPosition = newY;
      }
    },
    endDrag() {
      if (this.contentPosition <= 0) {
        this.contentPosition = 0;
      } else if (this.contentPosition < 245 && this.prevPosition === 0) {
        this.contentPosition = 250;
      }  if (this.contentPosition > 255 && this.prevPosition === 0) {
        this.contentPosition = 350;
      } if (this.contentPosition < 245 && this.prevPosition === 250) {
        this.contentPosition = 0;
      } else if (this.contentPosition > 250 && this.prevPosition === 250) {
        this.contentPosition = 350;
      } else if (this.contentPosition < 350 && this.prevPosition === 350) {
        this.contentPosition = 250;
      } else if (this.contentPosition >= 350) {
        this.contentPosition = 350;
      }

      if (this.contentPosition === 0) {
        this.height = 250;
      } else {
        this.height = this.contentPosition;
      }
    },
  },
  mounted() {
    PeriodicalCalculateWatcher.init();
  },
  beforeDestroy() {
    PeriodicalCalculateWatcher.cleanup();
  },
};
</script>

<style lang="scss" scoped>
.periodical {
  width: 100%;
  display: flex;

  .periodical-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .result-container {
    z-index: 1;
    display: inline-block;
    position: relative;
    width: 40%;
  }
  .map-container {
    flex-grow: 1;
    height: auto;
    position: relative;
  }
}

.periodical-mobile {
  height: 100vh;
  .mobile-result-container {
    flex-direction: column;
    display: flex;
    height: 100%;
    box-sizing: border-box;

    .mobile-map {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .mobile-container {
      display: flex;
      flex-direction: column;
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      height: calc(100%);
      transition: transform 0.3s ease;
      will-change: transform;

      .scrollable-wrapper {
        overflow-y: auto;
        background-color: var(--bg-body-color);
      }
    }
  }
}

</style>